/**
 * Created by amirb on 11/10/14.
 */
define(function (require) {

    window.lpTag = window.lpTag || {};
    window.lpTag.WebAgent = window.lpTag.WebAgent || {};

    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');
    var lpSecureFormsController = require('web-agent-assets-js/lpSecureFormsController');
    var WidgetViewController = require('web-agent-framework/WidgetViewController');
    var privilegesController = require('web-agent-assets-js/lpPrivilegesController');
    var SearchInputViewController = require('web-agent-viewControllers/SearchInputViewController');
    var TabsViewController = require('web-agent-viewControllers/TabsViewController');
    var PreDefinedContentPanelViewController = require('web-agent-viewControllers/PreDefinedContentPanelViewController');
    var SecureFormPanelViewController = require('web-agent-viewControllers/SecureFormPanelViewController');

    var PreDefinedShortcutsManager = window.PreDefinedShortcutsManager || {};

    var applicationType = 'PreDefinedWidget';
    var logger = WebAgentLogger.getLogger(applicationType);
    var VIEW_MODES = {filtered: 'filtered', unfiltered: 'unfiltered'};

    var PreDefinedWidget = WidgetViewController.extend({
        ControllerName: applicationType,
        applicationType: applicationType,
        templateFile: "LP_base_widget.html",

        LPViewClasses: {
            searchable: "searchable",
            tabbable: "tabbable"
        },

        LPViewMap: {
            sectionWrapper: ".lpview_section_wrapper",
            contentPlaceholder: ".lpview_widget_content_placeholder"
        },

        initialize: function () {
            this.uiState = {};
            this.isPciCompliance = false;

            this.initView();
            this.resolveSecureFormsAvailability();
        },
        events: function () {
            this.bindModel({modelPath: "participants.myEngagements", callback: this.handleNewEngagement});
            this.bindModel({modelPath: "participants.simulatedEngagements", callback: this.handleNewEngagement});
            this.bindViewEvent({
                view: this.tabsVC.viewPort,
                DOMEvent: "scroll",
                callback: this.saveScrollPosition
            });
        },
        render: function () {
        }
    });


    /**
     * Initializing the view.
     */
    PreDefinedWidget.prototype.initView = function () {

        if (this.configuration.widgetDataConfig.search) {
            this.searchInputVC = new SearchInputViewController({
                inputBlurredWidth: "100%",
                inputFocusedWidth: "100%",
                preClearSearchCallback: this.preSearchOrClearSearch,
                clearSearchCallback: this.clearSearch,
                context: this
            });

            this.addViewController({viewController: this.searchInputVC, target: this.LPViewMap.contentPlaceholder});
            this.addClass(this.LPViewMap.contentPlaceholder, this.LPViewClasses.searchable);
        }

        this.tabsConfig = {
            tabs: [
                {
                    title: '(0)',
                    icon: 'text',
                    tooltip: this.translate('predefined_content_tab_tooltip'),
                    view: new PreDefinedContentPanelViewController({
                        modelController: this.modelController,
                        searchInputVC: this.searchInputVC,
                        preSearch: this.preSearchOrClearSearch.bind(this),
                        postSearch: this.postSearchOrClearSearch.bind(this),
                        events: {
                            visibleRowsCountCallback: this.handlePanelVisibleRowsCountCallback.bind(this)
                        }
                    })

                }
            ], selectedTabIndex: 0
            , onTabSelectionChange: this.handleTabSelectionChange.bind(this)
        };


        this.tabsVC = new TabsViewController(this.tabsConfig);
        this.addViewController({viewController: this.tabsVC, target: this.LPViewMap.contentPlaceholder});

    };

    /**
     * Handel tab change event.
     * @param tabIndex
     */
    PreDefinedWidget.prototype.handleTabSelectionChange = function (tabIndex) {
        this.restoreScrollPosition(tabIndex);
    };

    PreDefinedWidget.prototype.handlePanelVisibleRowsCountCallback = function (data) {
        if (!this.tabsVC) {
            return;
        }

        if (data.isFiltered) {
            this.tabsVC.setScrollPosition(0);
        }
        else {
            this.restoreScrollPosition(data.tabIndex);
        }

    };


    /**
     * check if we need to show the secure forms panel in the pre defined widget.
     */
    PreDefinedWidget.prototype.resolveSecureFormsAvailability = function () {
        var self = this;
        if ((lpTag.WebAgent.logicController.hasSecureFormsFeature() || lpTag.WebAgent.logicController.hasMessagingSecureFormFeature()) && privilegesController.hasSecureFormsViewPrivilege()) {
            this.bindModel({
                modelPath: lpSecureFormsController.SECURE_FORMS_PCI_COMPILANT_SETTINGS_STATE_MODEL_PATH,
                callback: onPciSettingsStateChanged
            });
        }

        function onPciSettingsStateChanged(data) {
            if (data && data.newValue && data.newValue !== lpSecureFormsController.DATA_STATES.FETCHING) {
                self.isPciCompliance = self.modelController.getModelParam(lpSecureFormsController.SECURE_FORMS_PCI_COMPILANT_SETTINGS_DATA_MODEL_PATH);

                if (data.newValue === lpSecureFormsController.DATA_STATES.SUCCESS) {
                    if (self.isPciCompliance) {
                        self.addSecureFormsTab();
                    }
                } else {
                    logger.error('cannot resolve pci compliance, service return error state.');
                }

                self.unbindModel({
                    modelPath: lpSecureFormsController.SECURE_FORMS_PCI_COMPILANT_SETTINGS_STATE_MODEL_PATH,
                    callback: onPciSettingsStateChanged
                });
            }
        }

    };


    /**
     * Adding the secure forms tab into the tabs controller.
     */
    PreDefinedWidget.prototype.addSecureFormsTab = function () {
        var secureFormsTab = {
            title: '(0)',
            icon: 'form',
            tooltip: this.translate('secure_forms_tab_tooltip'),
            view: new SecureFormPanelViewController({
                modelController: this.modelController,
                searchInputVC: this.searchInputVC
            })
        };
        this.tabsConfig.tabs.push(secureFormsTab);
        this.tabsVC.addTab(secureFormsTab);
        this.updateTabsMode();
    };

    /**
     * virtual method, get the configuration for the component in the ViewController life cycle.
     */
    PreDefinedWidget.prototype.getConfiguration = function () {
        return {
            widgetDataConfig: {search: true},
            updateDataCallback: this.refreshClicked,
            refreshCallback: this.refreshCallback.bind(this),
            context: this
        };
    };

    PreDefinedWidget.prototype.refreshCallback = function() {
        var panel = this.tabsConfig.tabs[this.tabsVC.selectedTabIndex].view;
        panel.refreshClicked();
    };

    PreDefinedWidget.prototype.preSearchOrClearSearch = function () {
        for (var i = 0; i < this.tabsConfig.tabs.length; i++) {
            var panel = this.tabsConfig.tabs[i].view;
            if (panel && panel.setState) {
                panel.setState('loading');
            }
        }
    };
    /**
     * clear the search and send a trigger to all of the panels that are in the tabs to clear the table filter.
     */
    PreDefinedWidget.prototype.clearSearch = function () {
        if(this.searchInputVC && this.searchInputVC.setText) {
            this.searchInputVC.setText('');
        }
        for (var i = 0; i < this.tabsConfig.tabs.length; i++) {
            var panel = this.tabsConfig.tabs[i].view;
            if (panel && panel.clearFiltering) {
                panel.clearFiltering();
            }
        }
        this.postSearchOrClearSearch();
    };

    PreDefinedWidget.prototype.postSearchOrClearSearch = function() {
        for (var i = 0; i < this.tabsConfig.tabs.length; i++) {
            var panel = this.tabsConfig.tabs[i].view;
            if (panel && panel.setState && panel.getRootModelPath) {
                var state = this.getModelParam(panel.getRootModelPath() + '.state') || 'success';
                panel.setState(state);
            }
        }
    };

    /**
     * handle a new engagement.
     * @param visitorId
     */
    PreDefinedWidget.prototype.handleSingleNewEngagement = function (visitorId) {
        this.unbindVisitor(visitorId);
        this.bindNewVisitor(visitorId);
    };

    /**
     * set up binding to a new visitor.
     * @param visitorId
     */
    PreDefinedWidget.prototype.bindNewVisitor = function (visitorId) {
        this.viewEventsHandler.bindEvent({
            appName: visitorId,
            UIEvent: this.eventType.VISITOR_DISPOSED,
            callback: this.visitorDisposed
        });
        this.viewEventsHandler.bindEvent({
            appName: visitorId,
            UIEvent: this.eventType.VISITOR_FOCUSED,
            callback: this.visitorFocus
        });
        this.viewEventsHandler.bindEvent({
            appName: visitorId,
            UIEvent: this.eventType.VISITOR_BLURRED,
            callback: this.visitorBlurred
        });
    };

    /**
     * unbind a visitor.
     * @param visitorId
     */
    PreDefinedWidget.prototype.unbindVisitor = function (visitorId) {
        this.viewEventsHandler.unbindEvent({
            appName: visitorId,
            UIEvent: this.eventType.VISITOR_FOCUSED,
            callback: this.visitorFocus
        });
        this.viewEventsHandler.unbindEvent({
            appName: visitorId,
            UIEvent: this.eventType.VISITOR_BLURRED,
            callback: this.visitorBlurred
        });
        this.viewEventsHandler.unbindEvent({
            appName: visitorId,
            UIEvent: this.eventType.VISITOR_DISPOSED,
            callback: this.visitorDisposed
        });
    };

    /**
     * handling new engagement.
     * @param data
     */
    PreDefinedWidget.prototype.handleNewEngagement = function (data) {
        for (var visitorId in data.newValue) {
            if (data.newValue.hasOwnProperty(visitorId)) {
                this.handleSingleNewEngagement(visitorId + "");
            }
        }
    };

    /**
     * handling the visitor focus on the widget, this is important lifecycle step that trigger that data shifting in the
     * panels.
     * @param data
     */
    PreDefinedWidget.prototype.visitorFocus = function (data) {
        if (!data.newValue) {
            return;
        }
        if (data.newValue.appName === this.focusedVisitorId) {
            return;
        }
        if (this.focusedVisitorId) {
            this.saveUiState();
        }

        this.focusedVisitorId = data.newValue.appName;

        this.updatePanelsVisitor(this.focusedVisitorId);

        this.setUiState();

        this.updateTabsMode();

    };


    /**
     * Updating the Tabs Mode.
     */
    PreDefinedWidget.prototype.updateTabsMode = function () {
        var newParticipantPath = lpTag.WebAgent.logicController.getParticipantPath(this.focusedVisitorId);
        var chatId = lpTag.WebAgent.logicController.getLatestChatId(newParticipantPath);

        var isRealTimeAndHasSecureFormsFeature = lpTag.WebAgent.logicController.isVisitorRealTimeChat(this.focusedVisitorId) && lpTag.WebAgent.logicController.hasSecureFormsFeature();
        var isAsyncMessagingAndHasSecureFormsFeature = lpTag.WebAgent.logicController.isVisitorAsyncMessaging(this.focusedVisitorId) && lpTag.WebAgent.logicController.hasMessagingSecureFormFeature();

        if ((isRealTimeAndHasSecureFormsFeature || isAsyncMessagingAndHasSecureFormsFeature) && this.tabsConfig.tabs.length > 1 && lpTag.WebAgent.logicController.isMyChat(chatId)) {
            this.addClass(this.LPViewMap.contentPlaceholder, this.LPViewClasses.tabbable);
        } else {
            this.removeClass(this.LPViewMap.contentPlaceholder, this.LPViewClasses.tabbable);
        }
    };

    /**
     * when the visitor leave the widget, we remove the binginds and save the UI state of the controll.
     * @param data
     */
    PreDefinedWidget.prototype.visitorBlurred = function (data) {
        if (!data.newValue) {
            return;
        }

        if (data.newValue.appName + "" === this.focusedVisitorId) {
            this.saveUiState();
            this.focusedVisitorId = null;
            this.updatePanelsVisitor(this.focusedVisitorId);
        }
    };

    /**
     * when the visitor is disposed, we disposing the ui state data and removing the binding of the visitor.
     * @param data
     */
    PreDefinedWidget.prototype.visitorDisposed = function (data) {
        if (data.newValue) {
            var visitorId = data.newValue.eventData.visitorId + "";
            this.unbindVisitor(visitorId);

            delete this.uiState[visitorId];
        }
    };

    /**
     * updateing the panels visitor id in the inner panels.
     * @param visitorId
     */
    PreDefinedWidget.prototype.updatePanelsVisitor = function (visitorId) {
        for (var i = 0; i < this.tabsConfig.tabs.length; i++) {
            var panel = this.tabsConfig.tabs[i].view;
            if (panel && panel.updateVisitor) {
                panel.updateVisitor(visitorId);
            }
        }
    };


    /**
     * Retrieve the current view mode.
     * @returns {*}
     */
    PreDefinedWidget.prototype.getViewMode = function () {
        if (this.searchInputVC && this.searchInputVC.getText() !== '') {
            return VIEW_MODES.filtered;
        }
        return VIEW_MODES.unfiltered;
    };

    /**
     * saving the UI state.
     */
    PreDefinedWidget.prototype.saveUiState = function () {
        var visitorId = this.focusedVisitorId;
        var viewMode = this.getViewMode();
        var stateObj = this.uiState[visitorId] || {};

        // visitor level state data.
        stateObj.selectedTabIndex = this.tabsVC.selectedTabIndex;
        stateObj.viewMode = viewMode;
        stateObj.searchQuery = this.searchInputVC && this.searchInputVC.getText();


        // view mode state data
        stateObj[viewMode] = stateObj[viewMode] || {};
        stateObj[viewMode].panels = getPanelsStates(this.tabsConfig.tabs);

        this.uiState[visitorId] = stateObj;
        function getPanelsStates(tabs) {
            var pStates = [];
            for (var i = 0; i < tabs.length; i++) {
                pStates.push(tabs[i].view.getUiState());
            }
            return pStates;
        }
    };

    /**
     * restoring a ui state.
     */
    PreDefinedWidget.prototype.setUiState = function () {
        var visitorId = this.focusedVisitorId;
        var state = this.uiState[visitorId];
        if (state) {
            // getting the ViewMode to restore.
            var viewMode = state.viewMode;

            // handling the search input.
            if (this.searchInputVC && !state.searchQuery) {
                this.searchInputVC.setText('');
                this.clearSearch();
            } else {
                this.searchInputVC.setText(state.searchQuery);
            }

            // handling the active tab index.
            if (this.tabsVC.selectedTabIndex !== state.selectedTabIndex) {
                this.tabsVC.setActiveTab(state.selectedTabIndex);
            }

            // handling the inner state of the panels.
            if (state && state[viewMode]) {
                var panels = state[viewMode].panels;
                // setting the table's state inside the panels.
                if (panels && panels.length) {
                    for (var i = 0; i < panels.length; i++) {
                        var panel = this.tabsConfig.tabs[i].view;
                        if (panel) {
                            panel.setUiState(panels[i]);
                        }
                    }
                }
            }

            // need to be on the differed in order to work.
            setTimeout((function () {
                this.restoreScrollPosition(state.selectedTabIndex);
            }).bind(this), 10);

        } else {
            this.setDefaultUiState();
        }
    };


    /**
     * Setting the Default ui state for the current visitor.
     */
    PreDefinedWidget.prototype.setDefaultUiState = function () {
        // Resetting the UI State.
        var DEFAULT_TABLE_VIEW_STATE = {
            openSectionsIds: {},
            openSectionsFilterIds: {}
        };

        if (this.tabsConfig && this.tabsConfig.tabs && this.tabsConfig.tabs.length) {
            // setting default ui state.
            for (var i = 0; i < this.tabsConfig.tabs.length; i++) {
                this.tabsConfig.tabs[i].view.setUiState(DEFAULT_TABLE_VIEW_STATE);
            }
        }

        this.tabsVC.setActiveTab(this.tabsConfig.selectedTabIndex);
        this.tabsVC.setScrollPosition(0);
        this.clearSearch();

        // saving the new state.
        this.saveUiState();
    };

    /**
     * saving the scroll position.
     */
    PreDefinedWidget.prototype.saveScrollPosition = function () {
        var visitorId = this.focusedVisitorId;
        var viewMode = this.getViewMode();
        var stateObj = this.uiState[visitorId] || {};

        stateObj[viewMode] = stateObj[viewMode] || {};
        stateObj[viewMode].scrollPosition = stateObj[viewMode].scrollPosition || {};
        stateObj[viewMode].scrollPosition[this.tabsVC.selectedTabIndex] = this.tabsVC.getScrollPosition();

        this.uiState[visitorId] = stateObj;
    };

    PreDefinedWidget.prototype.restoreScrollPosition = function (tabIndex) {
        if (!this.tabsVC) {
            return;
        }

        var visitorId = this.focusedVisitorId;
        var viewMode = this.getViewMode();
        var stateObj = this.uiState[visitorId] || {};

        if (stateObj[viewMode] && stateObj[viewMode].scrollPosition && stateObj[viewMode].scrollPosition.hasOwnProperty(tabIndex)) {
            this.tabsVC.setScrollPosition(stateObj[viewMode].scrollPosition[tabIndex]);
        } else {
            this.tabsVC.setScrollPosition(0);
        }
    };


    return PreDefinedWidget;

});
